var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46879 12.3312C8.16884 12.0312 8.00034 11.6243 8.00034 11.2C8.00034 10.7757 8.16884 10.3688 8.46879 10.0688L14.8688 3.6688C15.1688 3.36884 15.5757 3.20034 16 3.20034C16.4243 3.20034 16.8311 3.36884 17.1312 3.6688L23.5312 10.0688C23.8226 10.3706 23.9839 10.7747 23.9803 11.1942C23.9766 11.6138 23.8084 12.0151 23.5117 12.3117C23.2151 12.6084 22.8138 12.7766 22.3942 12.7803C21.9747 12.7839 21.5706 12.6227 21.2688 12.3312L17.6 8.6624V27.2C17.6 27.6243 17.4314 28.0313 17.1314 28.3314C16.8313 28.6314 16.4243 28.8 16 28.8C15.5756 28.8 15.1687 28.6314 14.8686 28.3314C14.5686 28.0313 14.4 27.6243 14.4 27.2V8.6624L10.7312 12.3312C10.4311 12.6312 10.0243 12.7997 9.59999 12.7997C9.17573 12.7997 8.76884 12.6312 8.46879 12.3312V12.3312Z",
    fill: "#57834F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowUp);
export default __webpack_public_path__ + "static/media/ico-arrow-up.3c2bdbcc0d81f2da76257c929f6916c4.svg";
export { ForwardRef as ReactComponent };